import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Cultivar } from 'src/app/classes/Cultivar';
import { Cultura } from 'src/app/classes/Cultura';
import { EstadioFenologico } from 'src/app/classes/EstadioFenologico';
import { CultivarService } from 'src/app/services/cultivar.service';
import { CulturaService } from 'src/app/services/cultura.service';
import { EstadioFenologicoService } from 'src/app/services/estadio-fenologico.service';
import { StorageService } from 'src/app/services/storage.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { ColumnModel, ForeignKeyService, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { finalize } from 'rxjs/operators';
import { FormsCultivarComponent } from './forms-cultivar/forms-cultivar.component';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-cultivar',
  templateUrl: './cultivar.component.html',
  styleUrls: ['./cultivar.component.scss'],
  providers: [ForeignKeyService],

})
export class CultivarComponent implements OnInit {

  @ViewChild("gridVariedades", { static: false })
  gridVariedades: SyncGridComponent;

  @ViewChild("FormsCultivar", { static: false })
  formsCultivar: FormsCultivarComponent;



  cultivares: Cultivar[] = [];
  auxCultivares: Cultivar[];
  cultivar: Cultivar;
  id: number;
  inserindo: boolean = false;
  carregando: boolean = false;
  isSuper: boolean = false;

  form: any;
  public isSubmit: boolean;
  textoBusca: string = "";
  perfilLogado: number = 0;

  culturas: Cultura[];
  cultivaresPadrao: Cultivar[];
  cultivaresPorCultura: Cultivar[];
  estadiosFenologicos: EstadioFenologico[];
  variedadeColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false
  removendo: boolean = false
  inativando: boolean = false
  duplicando: boolean = false
  gridHeight: string = '79vh';

  pageSettings?: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };


  FEITO: string = "Feito!";
  ERRO: string = "Erro!";
  CANCELAR: string = "Cancelar";
  SIM: string = "Sim";
  CONFIRMAR_DELETE: string = "Se deletar, esta ação não poderá ser desfeita!";
  DELETAR_PARAM: string;
  VARIEDADE_DELETADA: string = "Variedade deletada!";
  VARIEDADE_CADASTRADA: string = "Variedade cadastrada!";
  VARIEDADE_ALTERADA: string = "Variedade alterada!";

  constructor(private cultivaresService: CultivarService,
    private utils: UtilsService,
    private culturaService: CulturaService,
    private estadioFenologicoService: EstadioFenologicoService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private translate: TranslateService,
    private location: Location) {
  }

  ngOnInit() {
    var usuarioLogado = this.storageService.getUsuario();
    this.isSuper = usuarioLogado.isSuper;
    this.perfilLogado = usuarioLogado.Perfil;
    this.cultivar = new Cultivar();

    forkJoin([
      this.culturaService.getCulturas(),
      this.cultivaresService.getCultivaresPadrao(),
    ]).subscribe(([culturas, cultivaresPadrao]) => {
      this.culturas = culturas;
      this.cultivaresPadrao = cultivaresPadrao
      this.listarCultivares()
      this.configurarGrid()
    }, error => this.utils.getErro(error));

    this.estadioFenologicoService.getEstadiosFenologicos().subscribe(ret => {
      this.estadiosFenologicos = ret;
    }, err => this.utils.getErro(err));

    this.configurarGrid()
  }


  ajustarTamanhoGrid(): void {
    const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
    const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
    const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
    const title = document.querySelector('app-cultivar h5.titulo') as HTMLElement
    const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement
    const altura = window.innerHeight - navbar.offsetHeight - groupdroparea.offsetHeight - toolbar.offsetHeight - title.offsetHeight - pager.offsetHeight - 70
    this.gridHeight = `${altura}px`
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) this.pageSettings.pageSize = 20;
    else this.pageSettings.pageSize = 40
    this.pageSettings.pageSize
    this.variedadeColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false },
      {
        field: "Descricao",
        type: "string",
        headerText: "Nome",
        allowSorting: true,
      },
      {
        field: "CulturaId",
        headerText: "Cultura",
        allowSorting: true,
        foreignKeyField: "Id",
        foreignKeyValue: "Descricao",
        dataSource: this.culturas,
      },
      {
        field: "CultivarBaseId",
        headerText: "Tecnologia",
        allowSorting: true,
        foreignKeyField: "Id",
        foreignKeyValue: "Descricao",
        dataSource: this.cultivaresPadrao,
      },
      {
        field: "Obtentor",
        headerText: "Obtentor",
        type: "string",
        allowSorting: true,
      },
      {
        field: "Ciclo",
        headerText: "Dias de Ciclo",
        type: "number",
        allowSorting: true,
      },
      {
        field: "dataAlteracaoStr",
        type: "string",
        headerText: "Ult. Mod.",
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "descAtivo",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.Ativo);
        }
      } as ColumnModel,
    ]
    this.ajustarTamanhoGrid();
  }
  doubleClick(event): void {
    this.editar(event)
  }
  badgeStatusUsuario(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }
  selecionarCultivar() {
    this.ERRO = this.translate.instant("ERRO");

    this.carregando = true;
    this.cultivaresService.getCultivar(this.id).subscribe(res => {
      this.cultivar = new Cultivar();
      this.cultivar = res;
      this.changeCultura();
      this.carregando = false;
    },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      })
  }

  listarCultivares() {
    this.ERRO = this.translate.instant("ERRO");
    this.carregando = true;
    this.cultivaresService.listarTodos()
      .pipe(
        finalize(() => {
          this.carregando = false;
        })
      )
      .subscribe(
        (res: Cultivar[]) => {

          this.cultivares = res.map(u => Object.assign(new Cultivar(), u));;
          if (!this.inserindo)
            this.auxCultivares = res;
          if (this.textoBusca != '')
            this.filtrarCultivares();
        },
        err => {
          this.utils.getErro(err);
        })

  }

  novo(): void {
    if (!this.utils.verificarPermissaoUsuario('IncluirVariedade'))
      return;

    this.formsCultivar.abrirModal();
    //this.router.navigate(['/cadastros/variedade/inserir']);
  }

  editar(cultivar: Cultivar): void {
    let cultiv;
    if (!cultivar) {
      var variedades = this.gridVariedades.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;

      cultiv = { ...variedades[0] };
    }
    else
      cultiv = { ...cultivar }
    this.formsCultivar.abrirModal(cultiv);
  }

  confirmaDuplicar(): void {
    var variedades = this.gridVariedades.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "As variedades selecionadas serão duplicadas!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar variedades",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(variedades);
      }
    });
  }
  duplicar(variedades: Cultivar[]): void {
    this.duplicando = true
    this.cultivaresService.duplicar(variedades.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Variedades duplicadas com sucesso")
        this.listarCultivares();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }

  ValidarSelectApenasUm(): boolean {
    var variedades = this.gridVariedades.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (variedades.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }
  ValidarSelectUmOuMais(): boolean {
    var variedades = this.gridVariedades.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais) return
    var variedades = this.gridVariedades.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    const todasInativas = variedades.every(v => v.Ativo === false);
    const algumaInativa = variedades.some(v => v.Ativo === false);

    if (todasInativas) {
      this.utils.handleWarning("Todas as variedades selecionadas já estão inativas");
      return;
    }

    let texto = "As variedades selecionadas serão inativadas!";
    if (algumaInativa) {
      texto += '<br> Algumas variedades já estão inativas e serão ignoradas.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar variedades",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(variedades);
      }
    });

  }

  inativar(variedades: Cultivar[]): void {
    console.log(variedades);
    this.inativando = true
    this.cultivaresService.inativar(variedades.map(p => p.Id))
      .subscribe((res) => {
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const item = variedades.find(v => v.Id.toString() === id);
            const nomeItem = item ? item.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeItem}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao Inativar Variedades',
            html: `As seguintes Variedades não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else if (variedades.filter(v => v.Ativo === false).length > 0) {
          const erros: string[] = [];
          variedades.filter(v => v.Ativo === false).forEach(item => {
            const nomeItem = item ? item.Descricao : `ID ${item.Id}`;
            erros.push(`<b>${nomeItem}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: 'Erro ao Inativar Variedades',
            html: `As seguintes Variedades não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess("Variedades  inativados com sucesso");
        }
        this.listarCultivares();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }


  finalizarSaveCultivar(): void {
    this.listarCultivares();
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirVariedade'))
      return;

    this.ERRO = this.translate.instant("ERRO");
    this.FEITO = this.translate.instant("FEITO");
    this.CONFIRMAR_DELETE = this.translate.instant("CONFIRMAR_DELETE");
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    this.VARIEDADE_DELETADA = this.translate.instant("VARIEDADE_DELETADA");

    var variedades = this.gridVariedades.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "As Variedades selecionadas serão excluidas, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.removerVariedades(variedades)
    });
  }

  removerVariedades(variedades: Cultivar[]) {
    this.removendo = true;
    this.cultivaresService.deleteCultivares(variedades.map(p => p.Id)).subscribe(
      res => {
        console.debug('res: ', res)

        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais variedades falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const variedade = variedades.find(v => v.Id.toString() === id);
            const nomeVariedade = variedade ? variedade.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeVariedade}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir variedades',
            html: `As seguintes variedades não puderam ser excluídas:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todas as variedades foram excluídas
          this.utils.handleSuccess("Variedades excluídas com sucesso");
        }

        this.listarCultivares();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });

  }

  filtrarCultivares() {
    this.cultivares = this.auxCultivares.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    );
  }

  cancelar() {
    this.router.navigate(['/cadastros/variedade']);
  }

  getCultura(id: number): Cultura {
    if (!this.culturas)
      return null;

    let cultura = this.culturas.filter(x =>
      x.Id == id
    );

    return cultura.length > 0 ? cultura[0] : new Cultura();
  }

  getEstadioFenologico(id: number): EstadioFenologico {
    if (!this.estadiosFenologicos)
      return null;

    let estadio = this.estadiosFenologicos.filter(x =>
      x.Id == id
    );

    return estadio.length > 0 ? estadio[0] : new EstadioFenologico();
  }

  getEstadiosPorCultura(culturaId: number): EstadioFenologico[] {
    if (!this.estadiosFenologicos)
      return null;

    return this.estadiosFenologicos.filter(x =>
      x.CulturaId == culturaId
    );
  }

  getCultivaresPorCultura(culturaId: number): Cultivar[] {
    if (!this.cultivaresPadrao)
      return null;

    let r = this.cultivaresPadrao.filter(x =>
      x.CulturaId == culturaId
    );
    console.log(r);
    return r;
  }

  changeCultura(abrindoModal: boolean = false) {
    this.cultivaresPorCultura = this.getCultivaresPorCultura(this.formsCultivar.cultivar.CulturaId);

    if (abrindoModal)
      return;
    let tipo = this.cultivaresPadrao.find(c => c.Id === this.formsCultivar.cultivar.CultivarBaseId);
    if (tipo === null || tipo === undefined)
      this.cultivar.CultivarBaseId = null;
    else
      if (tipo.CulturaId !== this.cultivar.CulturaId)
        this.cultivar.CultivarBaseId = null;
  }

  changeCultivarPadrao() {
    if (this.inserindo) {
      let cultivarPadrao: Cultivar[] = this.cultivaresPadrao.filter(x => x.Id == this.formsCultivar.cultivar.CultivarBaseId);

      if (cultivarPadrao.length > 0) {
        this.formsCultivar.cultivar.Descricao = cultivarPadrao[0].Descricao;
        this.formsCultivar.cultivar.Obtentor = cultivarPadrao[0].Obtentor;
        this.formsCultivar.cultivar.PesoMilSemente = cultivarPadrao[0].PesoMilSemente;
        this.formsCultivar.cultivar.Germinacao = cultivarPadrao[0].Germinacao;
        this.formsCultivar.cultivar.Vigor = cultivarPadrao[0].Vigor;
      }
    }
  }

  getDescricaoTipo(cultivarId: number): string {
    if (!this.cultivaresPadrao)
      return "";
    else {
      let cultivar = this.cultivaresPadrao.find(x => x.Id == cultivarId);
      if (cultivar)
        return cultivar.Descricao;
      else
        return "";
    }
  }
}
